import { createRequestHelper } from '@utils/swr'
import { type CrossBrandMallCampaignsRequest } from '../types/apiRequest'
import { type CrossBrandMallCampaignsResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const {
  useRequest,
  getSwrFetcher,
} = createRequestHelper<FortuneApis['get']['crossBrandMallCampaigns'], CrossBrandMallCampaignsResponse, CrossBrandMallCampaignsRequest>({
  client: 'fortune',
  key: params => params?.mall_code ? `/cross-brand-malls/${params.mall_code}/campaigns` : null,
  isImmutable: true,
})

export const useApiCrossBrandMallCampaigns = useRequest
export const getCrossBrandMallCampaignsFetcher = getSwrFetcher
